




















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTagBox from 'devextreme-vue/tag-box';
import {
    ProjectsClient,
    GetMaterialOrderDesignInfoQuery,
    MaterialOrderDesignInfoDto,
    MaterialOrderDesignInfoDetails,
    OrdersClient,
    CreateMaterialOrderFromMeasuringStatesCommand,
    SuppliersClient,
    ContactBasicsDto,
} from '@/data/web-api-client';

enum selectionMode {
    cheapest = 0,
    default = 1,
}

@Component({
  components: {
    Popup,
    DxSelectBox,
    DxTagBox,
  },
})
export default class ProjectDesignOrderPopup extends Vue {
    @Prop({ required: true })
    private projectId!: string;

    @Prop({ required: true })
    private documentNumbers!: string[];

    private show: boolean = false;
    private saving: boolean = false;
    private data: MaterialOrderDesignInfoDto[] = [];
    private projectClient: ProjectsClient = new ProjectsClient(undefined, this.$axios);
    private suppliersClient: SuppliersClient = new SuppliersClient(undefined, this.$axios);
    private suppliers: ContactBasicsDto[] = [];
    private preferredSupplierId: string = '';
    private preferredBrands: string[] = [];
    private preferredMode: selectionMode = selectionMode.cheapest;

    public open() {
        this.show = true;
        setTimeout(() => {
            this.loadData();
        }, 150);
    }

    private created() {
        this.loadSuppliers();
    }

    private async loadSuppliers() {
        this.suppliers = await this.suppliersClient.getAll();
    }

    private async loadData() {
        this.data = await this.projectClient.designMaterialOrder(new GetMaterialOrderDesignInfoQuery({
            projectId: this.projectId,
            documentNumbers: this.documentNumbers,
        }));
    }

    private async save() {
        try {
            this.saving = true;
            const orderClient = new OrdersClient(undefined, this.$axios);
            await orderClient.createMaterialOrderFromMeasuringStates(new CreateMaterialOrderFromMeasuringStatesCommand({
                projectId: this.projectId,
                lines: this.data,
            }));
            this.show = false;
            this.$emit('orderCreated');
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    private selectOption(details: MaterialOrderDesignInfoDetails, id: string, info: MaterialOrderDesignInfoDto) {
        const obj = details.supplierDetails!.find((o: any) => o.supplierId === id);
        if (!obj) {
            return;
        }

        info.details!.forEach((d) => {
            if (!d.supplierDetails) {
                return;
            }

            d.supplierDetails!.forEach((element) => {
                element.selected = false;
            });

            if (d.brand === details.brand && d.kind === details.kind) {
                // tslint:disable-next-line:no-shadowed-variable
                const o = details.supplierDetails!.find((o) => o.supplierId === id);
                if (o) {
                    o.selected = true;
                }
            }
        });
    }

    private select() {
        // 1. Transform data to manipulate with ease
        // 2. Filter Preferred Supplier
        // 3. Filter Preferred Brands
        // 4. Take cheapest or default

        this.data.forEach((dataEntry) => {
            if (!dataEntry.details) {
                return;
            }

            // Transform data
            let transformedData: Array<{
                supplierId: string,
                brand: string | undefined,
                kind: string | undefined,
                total: number,
                default: boolean,
            }> = [];

            dataEntry.details.forEach((details) => {
                if (!details.supplierDetails) {
                    return;
                }

                details.supplierDetails.forEach((supplierDetails) => {
                    supplierDetails.selected = false; // remove selection

                    const transformedDataEntry = {
                        supplierId: supplierDetails.supplierId!,
                        brand: details.brand,
                        kind: details.kind,
                        total: supplierDetails.total!,
                        default: supplierDetails.isDefault!,
                    };

                    // prevent multiple defaults
                    if (transformedData.findIndex((o) => o.default) !== -1) {
                        transformedDataEntry.default = false;
                    }

                    transformedData.push(transformedDataEntry);
                });
            });

            // Filter : PreferredSupplier
            if ( this.preferredSupplierId && this.preferredSupplierId !== '' ) {
                const filteredData = transformedData.filter((o) => o.supplierId === this.preferredSupplierId);
                if (filteredData.length > 0) {
                    transformedData = filteredData;
                }
            }

            // Filter : Brand
            if ( this.preferredBrands && this.preferredBrands.length > 0 ) {
                const filteredData = transformedData
                    .filter((o) => o.brand && this.preferredBrands.findIndex((s) => s === o.brand) !== -1);
                if (filteredData.length > 0) {
                    transformedData = filteredData;
                }
            }

            let wantedOption: any = null;
            if (this.preferredMode === selectionMode.default) {
                const defaultValue = transformedData.find((o) => o.default);
                if (defaultValue) {
                    wantedOption = defaultValue;
                }
            }

            // find cheapest option
            if (wantedOption === null) {
                transformedData.forEach((entry) => {
                    if (wantedOption === null) {
                        wantedOption = entry;
                    } else {
                        if (wantedOption.total > entry.total) {
                            wantedOption = entry;
                        }
                    }
                });
            }

            let foundEntry: boolean = false;
            dataEntry.details!.forEach((details) => {
                details.supplierDetails!.forEach((supplierDetail) => {
                    if (foundEntry === false && details.brand === wantedOption.brand
                    && details.kind === wantedOption.kind
                    && supplierDetail.supplierId === wantedOption.supplierId
                    && supplierDetail.total === wantedOption.total) {
                        supplierDetail.selected = true;
                        foundEntry = true;
                    }
                });
            });
        });
    }

    private getPrice(details: any, id: any) {
        const obj = details.supplierDetails.find((o: any) => o.supplierId === id);
        if (obj && obj.unitPrice) {
            obj.unitPrice = Math.round(obj.unitPrice * 10000) / 10000;
            obj.total = Math.round(obj.total * 100) / 100;
            obj.quantity = Math.round(obj.quantity * 100) / 100;
        }
        return obj ? `€ ${obj.total}<br />(€${obj.unitPrice} x ${obj.quantity}${obj.measuringUnit})` : '-';
    }

    private isSelected(details: any, id: any) {
        const obj = details.supplierDetails.find((o: any) => o.supplierId === id);
        return obj ? obj.selected : false;
    }

    private getSupplierName(id: string) {
        const supplier = this.suppliers.find((o: any) => o.id === id);
        return supplier ? supplier.displayName : '';
    }

    get colSpan() {
        return 2 + this.supplierIds.length;
    }

    get brands(): string[] {
        const result: string[] = [];

        this.data.forEach((dataEntry) => {
            dataEntry.details!.forEach((details) => {
                if ( details.brand && details.brand !== '' && result.findIndex((s) => s === details.brand) === -1) {
                    result.push(details.brand);
                }
            });
        });

        return result;
    }

    get modes() {
        return [
            { value: selectionMode.cheapest, text: 'Goedkoopst' },
            { value: selectionMode.default, text: 'Standaard' },
        ];
    }

    get supplierTotals() {
        const result: Array<{id: string, total: number}> = [];

        this.supplierIds.forEach((id) => {
            result.push({
                id,
                total: 0,
            });
        });

        this.data.forEach((dataEntry) => {
            dataEntry.details!.forEach((details) => {
                details.supplierDetails!.forEach((supplierDetail) => {
                    if (supplierDetail.selected) {
                        result.find((o) => o.id === supplierDetail.supplierId!)!.total += supplierDetail.total!;
                    }
                });
            });
        });

        return result;
    }

    get supplierIds(): string[] {
        const list: string[] = [];

        this.data.forEach((info) => {
            if (!info.details) {
                return;
            }

            info.details.forEach((details) => {
                if (!details.supplierDetails) {
                    return;
                }

                details.supplierDetails.forEach((element) => {
                    if (!element.supplierId) {
                        return;
                    }

                    if (list.indexOf(element.supplierId) === -1) {
                        list.push(element.supplierId);
                    }
                });
            });
        });

        return list;
    }

    @Watch('preferredSupplierId')
    private onPreferredSupplierChanged() {
        this.select();
    }

    @Watch('preferredMode')
    private onPreferredModeChanged() {
        this.select();
    }

    @Watch('preferredBrands', { deep: true })
    private onPreferredBrandsChanged() {
        this.select();
    }
}
